var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback",class:{
        'is-login': _vm.optName,
    }},[_c('div',{on:{"click":_vm.handleFeedback}},[_c('veui-icon',{ref:"feedbackRef",attrs:{"name":"file-edit"}}),_c('veui-tooltip',{attrs:{"position":"bottom","target":"feedbackRef","ui":"reverse","hide-delay":100,"overlay-class":"feedback-overlay"}},[_vm._v(" 意见反馈 ")])],1),_c('feedback-dialog',{attrs:{"open":_vm.openFeedback},on:{"update:open":function($event){_vm.openFeedback=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }